import { render, staticRenderFns } from "./Conversion.vue?vue&type=template&id=977c2b0a&scoped=true"
import script from "./Conversion.vue?vue&type=script&lang=js"
export * from "./Conversion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977c2b0a",
  null
  
)

export default component.exports